import { ReportingService } from 'app/model/services/reporting.service';
import { CostReportService } from './model/services/cost-report.service';
import { MatIconModule } from '@angular/material/icon';
import { MatTreeModule } from '@angular/material/tree';
import { DrawPaneComponent } from './components/draw-pane/draw-pane.component';
import { RouteConfigDialogService } from './components/dialogs/route-config-dialog/route-config-dialog.service';
import { RouteService } from './model/services/route.service';
import { RoutesService } from './model/services/routes.service';
import { ProjectsComponent } from './pages/projects/projects.component';
import { AttributeOptionEditorDialogService } from './components/dialogs/attribute-option-editor-dialog/attribute-option-editor-dialog.service';
import { AttributeConditionsDialogService } from './components/dialogs/attribute-conditions-dialog/attribute-conditions-dialog.service';
import { ProjectSaveDialogService } from './components/dialogs/project-save-dialog/project-save-dialog.service';
import { ProjectLoadDialogService } from './components/dialogs/project-load-dialog/project-load-dialog.service';
import { HttpClientModule  } from '@angular/common/http';
import { EnvService } from 'app/env.service';
import { ServerService } from 'app/model/services/api-services/server.service';
import { ModalMessagerService } from './components/dialogs/modal-messager/modal-messager.service';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TestComponent } from './components/test/test.component';
import { ProjectConfigComponent } from './components/project-config/project-config.component';
import { ProjectConfigDialogComponent, ProjectConfigDialogEntryComponent } from './components/dialogs/project-config-dialog/project-config-dialog.component';
import { ViewStackComponent } from './components/view-stack/view-stack.component';
import { ViewStackViewComponent } from './components/view-stack/view-stack-view/view-stack-view.component';
import { GeneralViewComponent } from './components/project-config/general-view/general-view.component';
import { AttributeListingComponent } from './components/project-config/attribute-listing/attribute-listing.component';
import { PresetListingComponent } from './components/project-config/preset-listing/preset-listing.component';
import { SupplementalListingComponent } from './components/project-config/supplemental-listing/supplemental-listing.component';
import { ModalMessagerComponent, ModalMessagerContentComponent } from './components/dialogs/modal-messager/modal-messager.component';
import { FormsModule } from '@angular/forms';
import { ProjectLoadDialogComponent, ProjectLoadEntryComponent } from './components/dialogs/project-load-dialog/project-load-dialog.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AddressFinderComponent } from './components/address-finder/address-finder.component';
import { AttributeWorkspaceComponent } from './components/project-config/attribute-workspace/attribute-workspace.component';
import { ProjectSaveDialogComponent } from './components/dialogs/project-save-dialog/project-save-dialog.component';
import { AttributeConditionsDialogComponent, AttributeConditionsDialogEntryComponent } from './components/dialogs/attribute-conditions-dialog/attribute-conditions-dialog.component';
import { AttributeComparisonComponent } from './components/attribute-comparison/attribute-comparison.component';
import { ComparisonSelectorComponent } from './components/comparison-selector/comparison-selector.component';
import { AttributeSelectorComponent } from './components/attribute-selector/attribute-selector.component';
import { AttributeOptionSelectorComponent } from './components/attribute-option-selector/attribute-option-selector.component';
import { AttributeOptionEditorDialogComponent, AttributeOptionEditorDialogEntryComponent } from './components/dialogs/attribute-option-editor-dialog/attribute-option-editor-dialog.component';
import { AttributeEditorComponent } from './components/address-finder/attribute-editor/attribute-editor.component';
import { AttributeOptionEditorComponent } from './components/attribute-option-editor/attribute-option-editor.component';
import { AttributeOptionLineStylerComponent } from './components/attribute-option-editor/attribute-option-line-styler/attribute-option-line-styler.component';
import { LineStyleSwatchComponent } from './components/attribute-option-editor/attribute-option-line-styler/line-style-swatch/line-style-swatch.component';
import { IteratePipe } from './model/pipes/iterate.pipe';
import { AttributeOptionPointStylerComponent } from './components/attribute-option-editor/attribute-option-point-styler/attribute-option-point-styler.component';
import { AttributeOptionPointSwatchComponent } from './components/attribute-option-editor/attribute-option-point-styler/attribute-option-point-swatch/attribute-option-point-swatch.component';
import { CalculationMethodSelectorComponent } from './components/calculation-method-selector/calculation-method-selector.component';
import { PresetWorkspaceComponent } from './components/project-config/preset-workspace/preset-workspace.component';
import { DataEntryComponent } from './components/data-entry/data-entry.component';
import { LoginFormComponent } from './components/login-form/login-form.component';
import { ProjectListComponent } from './components/project-list/project-list.component';
import { ProjectsService } from './model/services/api-services/projects.service';
import { ProjectItemComponent } from './components/project-list/project-item/project-item.component';
import { ProjectComponent } from './pages/project/project.component';
import { MapComponent } from './components/map/map.component';
import { LayerListComponent } from './components/layer-list/layer-list.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { RouteConfigDialogComponent } from './components/dialogs/route-config-dialog/route-config-dialog.component';
import { RouteConfigEntryComponent } from './components/dialogs/route-config-dialog/route-config-entry/route-config-entry.component';
import { Injector } from '@angular/core';
import { ReportsComponent } from './components/reports/reports.component';
import { ReportCostsComponent } from './components/reports/report-costs/report-costs.component';
import { ReportSupplementalComponent } from './components/reports/report-supplemental/report-supplemental.component';
import { ReportSummaryComponent } from './components/reports/report-summary/report-summary.component';
import { OrgInfoComponent } from './components/org-info/org-info.component';
import { OrgMetadataComponent } from './components/org-info/org-metadata/org-metadata.component';
import { OrgEmployeesComponent } from './components/org-info/org-employees/org-employees.component';
import { OrgTemplatesComponent } from './components/org-info/org-templates/org-templates.component';
import { OrgsComponent } from './components/orgs/orgs.component';
import { SearchFilterComponent } from './components/search-filter/search-filter.component';
import { PagingComponent } from './components/search-filter/paging/paging.component';
import { OrgConfigsComponent } from './components/org-info/org-configs/org-configs.component';
import { ReportNavComponent } from './components/reports/report-nav/report-nav.component';
export let AppInjector!: Injector;

@NgModule({
    declarations: [
        AppComponent,
        TestComponent,
        ProjectConfigComponent,
        ProjectConfigDialogComponent,
        ProjectConfigDialogEntryComponent,
        ViewStackComponent,
        ViewStackViewComponent,
        GeneralViewComponent,
        AttributeListingComponent,
        PresetListingComponent,
        SupplementalListingComponent,
        ModalMessagerComponent,
        ModalMessagerContentComponent,
        ProjectLoadDialogComponent,
        ProjectSaveDialogComponent,
        AddressFinderComponent,
        AttributeWorkspaceComponent,
        AttributeConditionsDialogComponent,
        AttributeComparisonComponent,
        ComparisonSelectorComponent,
        AttributeSelectorComponent,
        AttributeOptionSelectorComponent,
        AttributeConditionsDialogEntryComponent,
        AttributeOptionEditorDialogComponent,
        AttributeOptionEditorDialogEntryComponent,
        AttributeEditorComponent,
        AttributeOptionEditorComponent,
        AttributeOptionLineStylerComponent,
        LineStyleSwatchComponent,
        IteratePipe,
        AttributeOptionPointStylerComponent,
        AttributeOptionPointSwatchComponent,
        CalculationMethodSelectorComponent,
        PresetWorkspaceComponent,
        DataEntryComponent,
        LoginFormComponent,
        ProjectsComponent,
        ProjectListComponent,
        ProjectItemComponent,
        ProjectComponent,
        MapComponent,
        LayerListComponent,
        RouteConfigDialogComponent,
        RouteConfigEntryComponent,
        DrawPaneComponent,
        ReportsComponent,
        ReportCostsComponent,
        ReportSupplementalComponent,
        ReportSummaryComponent,
        OrgInfoComponent,
        OrgMetadataComponent,
        OrgEmployeesComponent,
        OrgTemplatesComponent,
        OrgsComponent,
        SearchFilterComponent,
        PagingComponent,
        OrgConfigsComponent,
        ReportNavComponent

    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        AppRoutingModule,
        NgbModule,
        FormsModule,
        BrowserAnimationsModule,
        MatTreeModule,
        MatIconModule
    ],
    providers: [
        EnvService,
        ModalMessagerService,
        ServerService,
        EnvService,
        ProjectLoadDialogService,
        ProjectSaveDialogService,
        AttributeConditionsDialogService,
        AttributeOptionEditorDialogService,
        ProjectsService,
        RoutesService,
        RouteService,
        RouteConfigDialogService,
        CostReportService,
        ReportingService
    ],
    bootstrap: [AppComponent]
})

export class AppModule {
  constructor(private injector:Injector) {
    AppInjector = this.injector;
  }
 }
